// extracted by mini-css-extract-plugin
export default {"details-body":"DetailsBody_details-body__HJ4+p"};